import getWindow from "../window"
import {TESTING_VARIANT_KEY} from "../../config/constants"

export const getTestingVariant = (): string | undefined => {
    const window = getWindow()
    if (window) {
        const result = new URL(document.location.href).searchParams.get(TESTING_VARIANT_KEY)
        return result || undefined
    }
}

export const addTestingVariant = (apiUrl: string, testingVariant?: string) => {
    let url = apiUrl
    if (testingVariant) {
        url = `${apiUrl}?${TESTING_VARIANT_KEY}=${testingVariant}`
    }
    return url
}
